"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.StyledButton = exports.ErrorDescription = exports.StyledExclamationMarkIcon = exports.StyledFlex = exports.StyledContainer = void 0;
const flora_react_1 = require("@grupoboticario/flora-react");
const flora_react_icons_1 = require("@grupoboticario/flora-react-icons");
exports.StyledContainer = (0, flora_react_1.styled)('div', {
    display: 'flex',
    minHeight: '640px',
});
exports.StyledFlex = (0, flora_react_1.styled)(flora_react_1.Flex, {
    width: '100%',
    textAlign: 'center',
});
exports.StyledExclamationMarkIcon = (0, flora_react_1.styled)(flora_react_icons_1.ExclamationMarkHexagonIcon, {
    size: '$20',
    marginBottom: '$3',
});
exports.ErrorDescription = (0, flora_react_1.styled)(flora_react_1.Text, {
    color: '$medium-light-1',
    marginTop: '$2',
    marginBottom: '$6',
});
exports.StyledButton = (0, flora_react_1.styled)(flora_react_1.Button, {
    marginBottom: '$3',
});
